var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:(_vm.type + " toast")},[(_vm.icon)?_c('div',{staticClass:"icon"},[_c('i',{class:("fa " + _vm.icon)})]):_vm._e(),_c('div',{staticClass:"content"},[_c('div',{staticClass:"heading"},[_vm._t("header")],2),_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }